<template>
  <FormInput v-model="search" label="Zoek product" placeholder="Zoek op titel of id" name="search" />
  <div :class="$style['results']">
    <ProductCard v-for="product in results" :key="product.id" :product="product">
      <template #actions>
        <Button @click.stop="addRelatedProduct(id, product.id)">
          +
        </Button>
      </template>
    </ProductCard>
  </div>

  <div :class="$style['results']">
    <ProductCard v-for="product in related" :key="product.id" :product="product">
      <template #actions>
        {{ product }}
        <!-- <select v-model="product.relatedType">
          <option>Geen</option>
          <option>Set</option>
          <option>Similar</option>
        </select> -->
        <Button responsive icon="Trash" size="small" type="button" @click="detach(id, product.id)">
          Ontkoppel
        </Button>
      </template>
    </ProductCard>
  </div>
</template>
<script setup lang="ts">
import { watchDebounced } from '@vueuse/core'
const search: Ref<string | number | undefined> = ref()
const props = defineProps<{
  id?: number | string | null
  related?: object
}>()
const results: Ref<any> = ref(null)

watchDebounced(search, async () => {
  const { data } = await useApi('/products', {
    query: {
      q: search.value
    }
  })

  results.value = data.value
}, { debounce: 500, maxWait: 1000 })

const addRelatedProduct = async (childId:number) => {
  await useApi(`/products/${props.id}/related`, {
    method: 'POST',
    body: {
      relatedProductId: childId,
      relatedType: 'similar'
    }
  })
}
const detach = async (childId: number) => {
  await useApi(`/products/${props.id}/related/${childId}`, {
    method: 'DELETE'
  })
}

</script>
<style module>
.results {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: var(--spacing-l);
  width: 100%;
}
</style>
